module.exports = __webpack_public_path__ + "static/media/display-4.af414dba.png";